import React, { useEffect, useState } from "react";
import Icon from "../../../Elements/Icon/Icon.tsx";
import Form from "../../../Reusable/Form/Form.js";
import SocialIcons from "./SocialIcons.js";
import apiRequest from "../../../../utils/ApiRequest/apiRequest.js";
import useMailSender from "../../../../hooks/useMailSender.js";
// import getNewProp from "../../../../utils/getNewProp.js";
import Image from "components/Elements/Image/Image.tsx";
import CopyInput from "components/Reusable/ShareInput/CopyInput.js";
import { ShareFields } from "./ShareFields.js";
import { useToasts } from "react-toast-notifications";
import { useSideBar } from "../../../../contexts/sideBarContext/sideBarContext.js";
import { useMailView } from "../../../../contexts/mailViewContext/mailViewContext.js";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import { MultipleShareInput } from "./MultipleShareInput.js";
// import useInbox from "hooks/useInbox.ts";
import { useModal } from "../../../../contexts/modalContext/modalContext.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";

const ShareComponent = ({
  itemId,
  folderId,
  children,
  collection,
  mailData = { id: null },
  email,
  lightBox,
}) => {
  const { getTextByKey, getPath, getBasicSettingsData } = useContent();
  const { closeSlideBar } = useSideBar();
  const { getFilesSelection } = useMailView();
  // const { setMailDataProp } = useInbox();
  const { closeModal } = useModal();
  const {
    getMailMetaData,
    shareMail,
    getFilesData,
    getMailId,
    getIsCollection,
    getMailSecurity,
    getFoldersData,
  } = useMail();
  const { addToast } = useToasts();
  const { getUserData } = useUser();
  const { isMailSender } = useMailSender();
  const isInboxPage = window.location.pathname.includes("inbox");

  const globalCaptchaType = getBasicSettingsData()?.recaptchaType;

  const [fields, setFields] = useState(ShareFields);
  const [shareMailForm, setShareMailForm] = useState(email);
  const [isShareViaLink, setIsShareViaLink] = useState(true);
  const [mailLink, setMailLink] = useState(
    isInboxPage ? mailData?.shortUrl : email
  );

  // in case mail is with security by recipients only view - checking if its an owner and allows him an option to share only via mail
  useEffect(() => {
    if (getMailSecurity()?.recipientsOnly) {
      if (isMailSender()) {
        setShareMailForm(email || true);
      } else {
        closeSlideBar();
      }
    }
  }, [isMailSender(), getMailSecurity()?.recipientsOnly]);

  useEffect(() => {
    if (collection || window.location.href.includes("collection")) {
      const collectionId = collection?.encryptedCollectionId || getMailId();
      const currentPathBase =
        "https://" +
        window.location.host +
        getPath() +
        "collection/" +
        collectionId;

      setMailLink(
        mailData?.shortUrl
          ? `${mailData.shortUrl}/c/${collectionId}`
          : currentPathBase
      );
    } else {
      setMailLink(mailData?.shortUrl || email);
    }
  }, [collection, mailData?.shortUrl]);

  const handleSubmit = async (body) => {
    const filesList = itemId
      ? [itemId]
      : getFilesSelection().length > 0
      ? getFilesSelection()
      : collection?.selectedFileIds
      ? collection.selectedFileIds
      : null;

    const bodyRequest = {
      ...body,
      ShareToEmailRecipientTitle:
        typeof body.ShareToEmailRecipientTitle === "string"
          ? [body.ShareToEmailRecipientTitle]
          : body.ShareToEmailRecipientTitle,
      FilesList: filesList,
      mailId: mailData.id || getMailId(),
      collectionId: mailLink?.includes("collection")
        ? mailLink.split("collection/")[1]
        : false,
      // captchaServiceName: "cloudflare",
    };
    const response = await shareMail({
      body: bodyRequest,
      folderId: folderId,
      token: mailData.CSRFtoken,
    });
    if (response.status === "success") {
      addToast(getTextByKey("share-mail-success"), { appearance: "success" });
      if (mailData.id) {
        // const newProp = getNewProp(
        //   response.data,
        //   getBasicSettingsData().userVideoToken
        // );
        // setMailDataProp(mailData.id, ["CSRFtoken"], [newProp]);
        closeModal();
      } else {
        closeSlideBar();
      }
      return {
        status: response.status,
      };
    } else
      return {
        status: response.status,
        message: response.data,
      };
  };

  useEffect(() => {
    if (isInboxPage) return;

    const currentPathBase =
      "https://" +
      window.location.host +
      getPath() +
      (window.location.pathname.includes("collection")
        ? "collection/"
        : "gallery/") +
      (mailData.id || getMailId()) +
      "/";
    if (itemId || lightBox) {
      setMailLink(currentPathBase + itemId);
    } else if (getFilesSelection().length > 0 || folderId) {
      getFilesSelection().length === 1 && !folderId
        ? setMailLink(currentPathBase + getFilesSelection().toString())
        : setMailLink("");
    } else if (collection) {
      return;
    } else if (mailData.id) {
      setMailLink(currentPathBase);
    } else if (window.location.href.includes("collection")) {
      setMailLink(getMailMetaData().shortUrl + "/u/c/" + getMailId());
    } else {
      setMailLink(getMailMetaData().shortUrl);
    }
  }, [itemId, getFilesSelection(), folderId, mailData?.id, isInboxPage]);

  useEffect(() => {
    setFields((prev) => {
      return {
        ...prev,
        ShareToEmailRecipientTitle: {
          element: "customelement",
          fieldKey: "ShareToEmailRecipientTitle",
          validation: {
            validate: (array) => array.length > 0,
          },
          render: (props) => (
            <MultipleShareInput
              {...props}
              defaultValue={[email]}
              recipientsList={
                mailData.recipientsList || getMailMetaData().RecipientsList
              }
            />
          ),
        },
      };
    });
  }, []);

  const handleGenerateCollection = async () => {
    const currentDate = new Date();
    const collectionNameForAPI = `${currentDate.getMonth()}/${currentDate.getDate()}/${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const response = await apiRequest(
      "Collection",
      "ReactCreateCollection",
      {
        encryptedMailId: getMailId() || mailData.id,
        userId: getUserData().UserId,
        folderPathId: folderId,
        collectionName: collectionNameForAPI,
        selectedItems: getFilesSelection(),
        isCollection: getIsCollection(),
      },
      "POST"
    );

    if (response.status === "success") {
      const data = response.data;
      const currentPathBase =
        "https://" +
        window.location.host +
        getPath() +
        "collection/" +
        data.encryptedCollectionId;
      setMailLink(currentPathBase);
      setIsShareViaLink(true);
    }
  };

  return (
    <div className="share-component">
      <div className="share-title">
        {itemId
          ? getTextByKey("share-file-title")
          : folderId
          ? getTextByKey("share-folder-title")
          : getFilesSelection().length > 0
          ? getTextByKey("share-selected-files-title")
          : getTextByKey("share-mail-title")}
      </div>
      {itemId || getFilesSelection().length > 0 || folderId ? (
        <div className="share-file-info">
          <div className="file-image">
            {itemId ? (
              getFilesData()[itemId]?.ThumbSrc ? (
                <Image src={getFilesData()[itemId]?.ThumbSrc} />
              ) : (
                <Icon name={"file"} darkGray />
              )
            ) : folderId ? (
              <Icon name={"folder"} darkGray />
            ) : getFilesSelection().length > 0 ? (
              getFilesData()[getFilesSelection()[0]]?.ThumbSrc ? (
                <Image src={getFilesData()[getFilesSelection()[0]]?.ThumbSrc} />
              ) : (
                <Icon name={"file"} darkGray />
              )
            ) : (
              <Icon name={"file"} darkGray />
            )}

            {getFilesSelection().length > 0 && !itemId && !folderId ? (
              <div className="share-collection-icon">
                <Icon name="collections" white />
              </div>
            ) : null}
          </div>
          {itemId
            ? getFilesData()[itemId]?.Name
            : folderId
            ? getFoldersData()[folderId]?.folderName
            : getFilesSelection().length + " " + getTextByKey("files")}
        </div>
      ) : null}
      {(getFilesSelection().length > 1 || folderId) && !mailLink ? (
        <div className="share-link" onClick={handleGenerateCollection}>
          <Icon name="link-symbol" blue large clickable />
          <span>{getTextByKey("generate-a-link")}</span>
        </div>
      ) : null}
      {mailLink && !getMailSecurity()?.recipientsOnly ? (
        <div className="share-icons-container">
          <SocialIcons
            {...{
              setShareMailForm,
              setIsShareViaLink,
              mailLink,
              isShareViaLink,
            }}
          />
        </div>
      ) : null}

      {shareMailForm ? (
        <Form
          fields={fields}
          onSubmit={handleSubmit}
          submitProps={{
            title: getTextByKey("share"),
            errorWithBackground: true,
          }}
          defaultValuesObj={{
            ShareToEmailSenderTitle: getUserData()?.UserName,
            ShareToEmailRecipientTitle: email || "",
            ShareToEmailSubjectTitle: getMailMetaData().subjectText,
          }}
          // captchaProvider="cloudflare"
          // cloudflareActionName="shareMail"
        ></Form>
      ) : isShareViaLink ? (
        <CopyInput mailLink={mailLink} />
      ) : null}
    </div>
  );
};

export default ShareComponent;
